/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import classNames from 'classnames';

import { IAttrStyled } from '../../../types/globalTypes';
import EllipsisText from '../EllipsisText/EllipsisText';
import { BadgeStatusStyled } from './styled/BadgeStatusStyled';

export enum EBadgeStatus {
    active = 'active',
    blocked = 'blocked',
    changed = 'changed',
    future = 'future',
}

export interface IBadgeStatus extends IAttrStyled {
    isDisableTooltip?: boolean;
    status: EBadgeStatus;
    text: string;
}

const BadgeStatus = ({ isDisableTooltip, status, text, ...attrStyled }: IBadgeStatus) => {
    return (
        <BadgeStatusStyled
            {...attrStyled}
            className={classNames(attrStyled.className, `badge-status_${status}`)}
        >
            <EllipsisText
                lines={1}
                title={isDisableTooltip ? '' : text}
                titleAlign="center"
            >
                {text}
            </EllipsisText>
        </BadgeStatusStyled>
    );
};

export default BadgeStatus;
